import ArrowRightBlack from "assets/ArrowRightBlack.svg";
export const texts = {
  back: "voltar",
  message: "mensagem",
};

export const images = {
  ArrowRightBlack,
};
